import {
  faCircleCheck,
  faRecordVinyl,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import prize from "../../../assets/icons/gift_box.png";

import min_30 from "../../../assets/icons/30min.png";
import partyFlag from "../../../assets/partyFlag.png";
import NextBatchRegCard from "./../../CourseRegistration/NextBatchRegCard";
import RegisterNow from "./../../utils/RegisterNow";
import AqeedahCourseFee from "./AqeedahCourseFee";
import AqeedahSchedule from "./AqeedahSchedule";
import AqeedahLevel1Card from "./Levels/AqeedahLevel1Card";
import AqeedahLevel2Card from "./Levels/AqeedahLevel2Card";
import AqeedahLevel3Card from "./Levels/AqeedahLevel3Card";
import AqeedahCourseTeacher from "./Registration/AqeedahCourseTeacher";

const aqeedah_1_syllabus = [
  "আক্বীদার পরিচয়",
  "সহীহ আক্বীদার গুরুত্ব",
  "তাওহীদের প্রকারভেদ আলোচনা",
  "তাওহীদুল রুবূবিয়াহর গভীর জ্ঞান",
  "তাওহীদুল উলূহিয়াহর মর্মার্থ",
  "আসমা ওয়াস-সিফাতের সঠিক বিশ্বাস",
  "আল্লাহর নাম ও গুণাবলী",
  "দ্বীনের ৩টি ধারাবাহিক স্তর",
  "ইসলামের মূল ৫টি রুকন",
  "কালিমার না-বাচক অর্থ",
  "কালিমার হ্যাঁ-বাচক অর্থ",
  "আল্লাহর প্রতি পূর্ণ আনুগত্য",
  "শিরকের সংজ্ঞা ও ভয়াবহতা",
  "ইসলাম ভঙ্গের প্রধান কারণসমূহ",
  "ঈমানের রুকন ও স্তম্ভসমূহ",
  "ফেরেশতাদের প্রতি সঠিক বিশ্বাস",
  "আসমানী কিতাবসমূহের প্রতি ঈমান",
  "রাসুলুল্লাহ (সা.)-এর প্রতি ভালোবাসা",
  "ইহসানের সংজ্ঞা ও দলীল",
  "একজন মুহসিনের জীবনচিত্র",
  "ইসলাম ও ঈমানের পার্থক্য",
  "আখলাক ও আদব গঠন",
  "পুলসিরাতের বিবরণ ও গুরুত্ব",
  "ক্বান্তারার বিবরণ ও মুক্তি",
  "জান্নাত ও জাহান্নামের আক্বীদা",
  "বিদআতের প্রকারভেদ ও পরিচয়",
  "আক্বীদাহগত বিভিন্ন ভ্রান্ত বিদআত",
  "আমল কবুলের দুটি শর্ত",
  "আক্বীদার সঠিক ও একমাত্র উৎস",
  "সুফীবাদের উৎপত্তি ও ইতিহাস",
  "উপমহাদেশীয় বিভিন্ন সুফী তরীকাসমূহ",
];
const aqeedah_2_syllabus = [
  "মানব জীবনের আসল ফিতরাত",
  "বিভ্রান্তি ও শিরকের ইতিহাস",
  "দ্বীনের ক্ষেত্রে বাড়াবাড়ির পরিণতি",
  "বিদআতের ভয়াবহ ক্ষতি ও গুনাহ",
  "রাসূলুল্লাহর মর্যাদা ও বৈশিষ্ট্য",
  "মূর্তিপূজার সূচনা ও অপসারণ",
  "বড় শিরকের বিস্তারিত বিবরণ",
  "শিরক সর্ববৃহৎ গুনাহ হওয়ার কারণ",
  "গাইরুল্লাহর নামে পশু যবেহ",
  "ইবাদত ও গোপন ভয়ের হুকুম",
  "গাইরুল্লাহর কাছে সাহায্য প্রার্থনা",
  "উত্তম ভরসা ও তাওয়াক্কুল",
  "ভালোবাসার মাধ্যমে শিরক চেনার উপায়",
  "কবর জিয়ারতের শরীয়তসম্মত পদ্ধতি",
  "নিষিদ্ধ ও শিরকী কবর জিয়ারত",
  "বরকত অর্জনের সঠিক শরয়ী উপায়",
  "নিষিদ্ধ পদ্ধতিতে বরকত গ্রহণের পরিণতি",
  "ছোট শিরক ও শপথের বিধান",
  "আল্লাহ ছাড়া অন্যের নামে মান্নত",
  "শাফায়াত কামনার সঠিক আক্বীদা",
];
const aqeedah_3_syllabus = [
  "ছোট শির্ক ও প্রকারভেদ",
  "রিয়া বা লোকদেখানো ইবাদত",
  "প্রকাশ্য ও গোপন শির্ক",
  "কুফরী ও তার প্রকারভেদ",
  "নিফাক বা কপটতার পরিচয়",
  "ফাসেকী ও তার বিধান",
  "জুলুম এবং তার পরিণতি",
  "ধর্মচ্যুতি বা মুরতাদ হওয়ার বিধান",
  "কাফের সাব্যস্ত করার নিয়ম",
  "তাকফীরের শর্ত ও বাধাসমূহ",
  "বাধ্য হয়ে কুফরীতে লিপ্ততা",
  "ফিৎনা ও তার কারণসমূহ",
  "ফিৎনাকালীন মুসলিমদের করণীয়",
];

const AqeedahInfo = () => {
  return (
    <div className="container mx-auto px-5 my-10">
      {/* Welcome  */}
      <section>
        <div className="rounded bg-gradient-to-tl from-sky-200 flex justify-between header-card">
          <div className="p-5">
            <p className="text-3xl">সহীহ আক্বীদাহ কোর্স সিরিজে</p>
            <p className="text-4xl">স্বাগতম!</p>
          </div>
          <div className="p-5 hidden md:inline">
            <div className="flex justify-between">
              <div className="text-right font-serif align-middle mr-10">
                <p className="text-4xl ">سلسلة دورة العقيدة الصحيحة</p>
                <p className="text-2xl">على منهج السلف الصالح</p>
              </div>
              <div>
                <img src={partyFlag} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Course Descripttion  */}
      <section className="my-10">
        <p className="text-xl">কোর্স পরিচিতিঃ</p>
        <p>
          এই কোর্সে আমরা কুরআন ও সুন্নাহর আলোকে আক্বীদাহ (তাওহীদ, শিরক, কুফুরি,
          নিফাক ইত্যাদি) শিখব, ইনশা আল্লাহ।{" "}
        </p>
        <p>
          আমরা কোন গতানুগতিক ফেরকা/দলের মতাদর্শ শিখব না। বরং সালাফগনের (সাহাবীগন
          (রাঃ), তাবেঈগন যেমনঃ ইমাম আবু হানিফা, ইমাম আহমাদ বিন হাম্বাল, ইমাম
          মালেক, ইমাম শাফেয়ী, এবং তাবে'তাবেঈগন) -এর বুঝ ও নীতি অনুযায়ী আক্বীদাহ
          শিখব । সৌদি আরবের মদিনা ইসলামী বিশ্ববিদ্যালয়সহ অন্যান্য বিশ্ববিদ্যালয়
          ও শিক্ষাপ্রতিষ্ঠানসমূহ, এবং ইসলামী দাওয়াহ সেন্টারগুলোতে যে সিলেবাস
          পড়ানো হয়, সেই সিলেবাস অনুযায়ী প্রতিটি বিষয় কুরআন ও হাদিস থেকে দলীলসহ
          শেখানো হবে।
        </p>
        <p>কোর্স ফী এককালীন, ভর্তির পর আর কোন টাকা দিতে হবে না।</p>
        <p>ক্লাসে পিডিএফ দেওয়া হবে, শিক্ষার্থীদেরকে প্রিন্ট করে নিতে হবে।</p>
      </section>

      <section className="my-10 md:my-32 md:flex  justify-around items-center">
        <div>
          <img className="" src={min_30} alt="" />
        </div>
        <div className="my-10 md:my-0">
          <p className="text-xl">দৈনিক অধ্যয়নের সময়</p>
          <p>
            কোর্সটি ভালোভাবে শেষ করতে হলে আপনাকে প্রতিদিন ৩০ মিনিট পড়তে হবে।
          </p>
          <p> </p>
        </div>
      </section>

      <section className="my-20">
        <div className="my-20 grid grid-cols-1 md:grid-cols-3 items-center gap-10 ">
          {/* in short  */}
          <section className=" ">
            <div>
              <p className="text-xl my-4">এক নজরে</p>

              <p>
                <FontAwesomeIcon
                  className="text-green-600 pr-2"
                  icon={faCircleCheck}
                />
                মোট ৩টি লেভেলে বিভক্ত কোর্স সিরিজ
              </p>
              <p>
                <FontAwesomeIcon
                  className="text-green-600 pr-2"
                  icon={faCircleCheck}
                />
                প্রতিটি লেভেল পরিকল্পিত ও ধারাবাহিকভাবে সাজানো
              </p>
              <p>
                <FontAwesomeIcon
                  className="text-green-600 pr-2"
                  icon={faCircleCheck}
                />
                প্রতিটি লেভেল লেভেল শেষে সার্টিফিকেট
              </p>
              <p>
                <FontAwesomeIcon
                  className="text-green-600 pr-2"
                  icon={faUserGroup}
                />
                পুরুষ - মহিলা আলাদা গ্রুপ
              </p>
              <p>
                <FontAwesomeIcon
                  className="text-green-600 pr-2"
                  icon="fa-solid fa-clock"
                />
                সপ্তাহে ৩ দিন রেকর্ডেড ক্লাস ও ক্লাস টেস্ট
              </p>
              <p>
                <FontAwesomeIcon
                  className="text-red-600 pr-2"
                  icon={faRecordVinyl}
                  fade
                />
                পরীক্ষার আগে আলোচনামূলক লাইভ ক্লাস
              </p>
              <p>
                <FontAwesomeIcon
                  className="text-green-600 pr-2"
                  icon={faCircleCheck}
                />
                সম্পূর্ণ কোর্স সিরিজ শেষ হবে প্রায় ৭.৫ মাসে
              </p>
            </div>
          </section>
          <div>
            <iframe
              className="w-full rounded m-3"
              height="300"
              src="https://www.youtube.com/embed/7d4oNyjvkNo"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>{" "}
          <div>
            <iframe
              className="w-full rounded m-3"
              height="300"
              src="https://www.youtube.com/embed/zEJtWI_1-Fg"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      {/* register now  */}
      <section>
        <RegisterNow course="aqeedah"></RegisterNow>
      </section>

      <section>
        <div className="mt-10">
          <p className="text-xl my-8">লেভেল ১ এর বিষয়বস্তুঃ</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {aqeedah_1_syllabus.map((item, i) => (
              <p key={i}>
                <FontAwesomeIcon
                  className="text-green-700 pr-2"
                  icon={faCircleCheck}
                />
                {item}
              </p>
            ))}
          </div>
        </div>

        <div className="mt-10">
          <p className="text-xl my-8">লেভেল ২ এর বিষয়বস্তুঃ</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {aqeedah_2_syllabus.map((item, i) => (
              <p key={i}>
                <FontAwesomeIcon
                  className="text-blue-700 pr-2"
                  icon={faCircleCheck}
                />
                {item}
              </p>
            ))}
          </div>
        </div>
        <div className="mt-10">
          <p className="text-xl my-8">লেভেল ৩ এর বিষয়বস্তুঃ</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {aqeedah_3_syllabus.map((item, i) => (
              <p key={i}>
                <FontAwesomeIcon
                  className="text-orange-700 pr-2"
                  icon={faCircleCheck}
                />
                {item}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* Gift */}
      <section className="my-20 bg-yellow-200 rounded p-5 gift-box">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center ">
          <div className="order-2 mx-auto">
            <p className="text-xl my-4">সেরা ১৫ জনকে পুরষ্কৃত করা হবে</p>
            <p className="font-bold">লেভেল ১ এ ১০ জন</p>
            <p>লেভেল ১ এ ৩টি ১০০ মার্কের MCQ পরীক্ষা হবে।</p>
            <p>
              পরীক্ষায় সর্বোচ্চ রেজাল্টকারীদের মধ্যে সেরা ১০ জনকে পুরষ্কৃত করা
              হবে।
            </p>
            <br />
            <p className="font-bold">লেভেল ২+৩ এ ৫ জন</p>
            <p>
              লেভেল ২ এ ৩টি ১০০ মার্কের MCQ পরীক্ষা এবং লেভেল ৩ এ ১টি ১০০
              মার্কের MCQ পরীক্ষা হবে।
            </p>
            <p>
              মোট ৪০০ মার্কের পরীক্ষায় সর্বোচ্চ রেজাল্টকারীদের মধ্যে সেরা ৫ জনকে
              পুরষ্কৃত করা হবে।
            </p>
          </div>
          <div className="order-1 md:order-3">
            <img className="rounded-lg block mx-auto my-10 " src={prize} />
          </div>
        </div>
      </section>

      {/* Levels  */}
      <section className="my-10">
        <p className="text-xl">লেভেল সমূহঃ</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 my-5">
          <AqeedahLevel1Card />
          <AqeedahLevel2Card />
          <AqeedahLevel3Card />
        </div>
      </section>

      {/* <section className="my-24">
        <div className="flex items-center">
          <span className="text-xl">ক্লাসের সময়ঃ </span>
          <div className="ml-3">
            <img className="" src={bd_flag} alt="" />
          </div>
          <span className="ml-3">বাংলাদেশের সময় অনুযায়ী</span>
        </div>
        <Aqeedah1Schedule />
        <Aqeedah2Schedule />
        <Aqeedah3Schedule />
      </section> */}
      <section>
        <AqeedahSchedule />
      </section>

      {/* Course Fee  */}
      <AqeedahCourseFee />

      {/* next batch  */}
      <section>
        {/* <NextBatchReg></NextBatchReg> */}
        <NextBatchRegCard course="aqeedah" />
      </section>

      {/* register now  */}
      {/* <section className="mx-auto my-20 lg:w-1/2 text-center">
        <Link to="/registration-aqeedah">
          <p className="p-3 bg-green-300 rounded shadow-md">
            টাকা পাঠানোর নাম্বার ও গ্রুপ লিংক এখানে{" "}
            <FontAwesomeIcon
              className="text-green-600"
              icon={faMousePointer}
              fade
            />
          </p>
        </Link>
      </section> */}

      {/* course teacher  */}
      <div>
        <AqeedahCourseTeacher />
      </div>
    </div>
  );
};

export default AqeedahInfo;
